import BaseComponent from "../../../../lib/components/BaseComponent";
import PropTypes from "prop-types";
import Button from "../buttons/Button";
import T from "../../../model/system/text_translations/Translator";
import LoadingButton from "@mui/lab/LoadingButton";
import shortid from "shortid";
import Grid from "@mui/material/Grid2";
import DialogBase from "../../../../lib/components/dialogs/DialogBase";
import React, {createRef} from "react";
import InputText from "../inputFields/InputText";
import Checkbox from "../../../../lib/components/checkbox/Checkbox";
import GF from "../../../../lib/utils/GF";

class DialogNewFilterEntry extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      listNameValue: GF.getValue(this.props.nameOfList, ''),
      useForSending: GF.getValue(this.props.useForSending, false)
    }
  }
  onClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  onDone = () => {
    if (this.props.onDone) {
      this.props.onDone(this.state.listNameValue, this.state.useForSending);
    }
  }

  listNameChange = (event) => {
    this.state.listNameValue = event.target.value;
  }

  checkboxChange = (event) => {
    this.state.useForSending = !!event.target.checked;
  }

  render() {
    this.state.listNameValue = this.props.nameOfList;
    this.state.useForSending = this.props.useForSending;
    let dialogContent = [<InputText key={createRef()} labelElement={'Name der Liste'} defaultValue={this.props.nameOfList} onChange={this.listNameChange}/>,
      <Checkbox key={createRef()} labelElement={'als Versandliste verwendbar'} checked={this.state.useForSending} onChange={this.checkboxChange}/>];

    return <DialogBase
      onCloseButtonClick={this.onClose}
      actions={<>
        <Button
          color=''
          onClick={this.onClose}
          autoFocus>
          {T.label_cancel()}
        </Button>
        <LoadingButton
          loading={this.state.isLoading}
          variant='contained'
          onClick={this.onDone}>
          {T.label_save()}
        </LoadingButton></>}
      key={shortid()}
      open={this.props.open}
      maxWidth={'xl'}
      title={T.label_filter_filter_manager()}
      scroll='paper'
      fullWidth>
      <Grid container spacing={2}>
        {dialogContent}
      </Grid>
    </DialogBase>;
  }
}

DialogNewFilterEntry.propTypes = {
  open: PropTypes.bool.isRequired,
  nameOfList: PropTypes.string,
  useForSending: PropTypes.bool,
  onClose: PropTypes.func,
  onDone: PropTypes.func
}
export default DialogNewFilterEntry;
